package top.wcpe.allincore.ui.runtime.event

import kotlin.jvm.JvmName

/**
 * 鼠标拖拽事件。
 *
 * @property mouseX 鼠标 X 坐标（屏幕/根坐标系）
 * @property mouseY 鼠标 Y 坐标
 * @property button 按键编号：0=左键，1=右键，2=中键
 * @property deltaX 相对上一帧的 X 位移
 * @property deltaY 相对上一帧的 Y 位移
 */
data class DragEvent(
    // 保留 Java 记录式访问器 ABI：消费方以 `event.deltaY()` 方法式调用
    @get:JvmName("mouseX") val mouseX: Double,
    @get:JvmName("mouseY") val mouseY: Double,
    @get:JvmName("button") val button: Int,
    @get:JvmName("deltaX") val deltaX: Double,
    @get:JvmName("deltaY") val deltaY: Double,
)
